/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

$(function(){
  const $hd = $('.p-hdFix');

  if($hd[0]) {
    const $h = $('.l-header');

    $(window).on('scroll', function(){
      if($(window).scrollTop() > $h.innerHeight()) {
        $hd.addClass('is-show');
      } else {
        $hd.removeClass('is-show');
      }
    });
  }
});

$(function(){
  const $menu = $('.p-hd__menuSP button');

  if($menu[0]) {
    const $nav = $('.p-hd__nav');

    $menu.on('click', function(){
      $menu.toggleClass('is-on');
      $nav.toggleClass('is-show');
    });
  }
});

$(function(){
  const $slider = $('.home-kv__slick');

  if($slider[0]) {
    $slider.slick({
      variableWidth: true,
      centerMode: true
    });
  }
});

$(function(){
  const $slider = $('.home-gallery__slick');

  if($slider[0]) {
    $slider.slick({
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: "linear",
      speed: 5000,
      swipe: false,
      pauseOnFocus: false,
      pauseOnHover: false,
      variableWidth: true,
      centerMode: true,
      arrows: false
    });
  }
});

$(function(){
  const $slider = $('.home-backNumber__items.-sp');

  if($slider[0]) {
    $slider.slick({
      infinite: false,
      variableWidth: true,
      centerMode: true,
      arrows: false
    });
  }
});
